
import './home-banner.component.css';
import Carousel from 'react-bootstrap/Carousel';

export function HomeBanner() {
    return (
        <>
            <div id="" className="">

            {/* <div className="bg-image bg-parallax overlay bg-home" ></div> */}

            <div className="">
                <div className="">                
                    <Carousel>
                    <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={require('../../../img/react-banner.png')}
                        alt="First slide"
                        />
                        {/* <Carousel.Caption>
                            <br></br>
                        <h3>First slide label</h3>
                        <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                        </Carousel.Caption> */}
                    </Carousel.Item>
                    {/* <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={require('../../../img/pythontraining.jpg')}
                        alt="First slide"
                        />
                        <Carousel.Caption>
                        <h3>First slide label</h3>
                        <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                        </Carousel.Caption>
                    </Carousel.Item> */}
                    <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={require('../../../img/angular-banner.png')}
                        alt="Second slide"
                        />

                        {/* <Carousel.Caption>
                        <h3>Second slide label</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                        </Carousel.Caption> */}
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={require('../../../img/python-banner.png')}
                        alt="Third slide"
                        />

                        {/* <Carousel.Caption>
                        <h3>Third slide label</h3>
                        <p>
                            Praesent commodo cursus magna, vel scelerisque nisl consectetur.
                        </p>
                        </Carousel.Caption> */}
                    </Carousel.Item>
                    </Carousel>
                    
                </div>
            </div>

            </div>
        </>
    )
}